<div class="comp-logic-container">
  <div class="divider-container">
    <span class="divider-line"></span>
    <span class="divider-text">AND</span>
    <span class="divider-line"></span>
  </div>
  <div class="dropdown-form-container">
    <cc-signature-logic-inputs
      class="sm-m-0"
      [complementaryRule]="complementaryRule"
      [canUpgradePlan]="canUpgradePlan"
      [inputRequiredMessage]="inputRequiredMessage"
      (delete)="onDelete()"
      (validateLogicRules)="validateComplementaryLogicRules()"
    />

    <!-- OR NESTED RULES -->
    <div
      class="nested-complementary-logic-container"
      data-test="nested-complementary-logic-container"
      *ngIf="enableNestedComplementaryLogicFeature">
      <div
        class="sm-w-full sm-flex sm-flex-col sm-gap-2"
        *ngFor="let nestedComplementaryRule of complementaryRule.complementaryRules || []"
      >
        <div class="divider-container">
          <span class="divider-line"></span>
          <span class="divider-text">OR</span>
          <span class="divider-line"></span>
        </div>

        <cc-signature-logic-inputs
          class="sm-m-0"
          [complementaryRule]="nestedComplementaryRule"
          [canUpgradePlan]="canUpgradePlan"
          [inputRequiredMessage]="inputRequiredMessage"
          (delete)="onDeleteNestedRule(nestedComplementaryRule._id)"
          (validateLogicRules)="validateLogicRules()"
        />
      </div>

      <button trigger type="button" class="or-button" (click)="onAddComplementaryLogic()">
        <i class="cc-icon cc-icon-plus"></i> OR
      </button>
    </div>
  </div>
</div>
